/**
 * Route paths for the library module, mounted under `/library`.
 * Single source of truth — reuse these instead of hard-coding `/library...` strings.
 * The child paths are relative to the `/library` wrapper route.
 */
export const LIBRARY_ROUTES = {
  root: "/library",
  expenseCategories: "expense-categories",
  materials: "materials",
  stages: "stages",
} as const;
